// Horizontal touch gestures belong to the menu; vertical scrolling and pinch
// zoom remain native. The left screen edge stays available for the OS gesture.
export const initMenuSwipeBack = (viewport, menu, getTrail, goBack) => {
  let gesture = null;
  let suppressClickUntil = 0;

  const reset = () => {
    if (!gesture) return;
    const previousGesture = gesture;
    gesture = null;
    if (viewport.hasPointerCapture(previousGesture.id)) {
      viewport.releasePointerCapture(previousGesture.id);
    }
    previousGesture.previous.element.removeAttribute("data-swipe-back");
    menu.removeAttribute("data-swiping");
    menu.style.removeProperty("--himml-menu-swipe-x");
  };

  viewport.addEventListener(
    "pointerdown",
    (event) => {
      reset();
      suppressClickUntil = 0;
      const trail = getTrail();
      if (
        !event.isPrimary ||
        event.pointerType === "mouse" ||
        trail.length < 2 ||
        event.clientX < 24
      )
        return;
      gesture = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        started: event.timeStamp,
        dragging: false,
        current: trail[trail.length - 1],
        previous: trail[trail.length - 2],
      };
    },
    { passive: true }
  );

  viewport.addEventListener("pointermove", (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const dx = event.clientX - gesture.x;
    const dy = Math.abs(event.clientY - gesture.y);
    if (!gesture.dragging) {
      if ((dy > 10 && dy > Math.abs(dx)) || dx < -10) {
        reset();
        return;
      }
      if (dx < 10 || dx < dy * 1.25) return;
      gesture.dragging = true;
      viewport.setPointerCapture(event.pointerId);
      gesture.previous.element.setAttribute("data-swipe-back", "");
      menu.dataset.swiping = "true";
    }
    if (event.cancelable) event.preventDefault();
    menu.style.setProperty(
      "--himml-menu-swipe-x",
      `${Math.max(0, Math.min(dx, viewport.clientWidth))}px`
    );
  });

  viewport.addEventListener("pointerup", (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const dx = event.clientX - gesture.x;
    const dy = Math.abs(event.clientY - gesture.y);
    const elapsed = Math.max(1, event.timeStamp - gesture.started);
    const distance = Math.min(100, Math.max(56, viewport.clientWidth * 0.2));
    const commit =
      gesture.dragging &&
      dx > dy * 1.25 &&
      (dx >= distance || (dx >= 32 && dx / elapsed > 0.5)) &&
      getTrail().at(-1) === gesture.current;
    if (gesture.dragging) {
      suppressClickUntil = performance.now() + 400;
      menu.dataset.animate = "true";
    }
    reset();
    if (commit) goBack(true);
  });

  viewport.addEventListener("pointercancel", reset);
  viewport.addEventListener("lostpointercapture", (event) => {
    // Moving implicit capture from a touched link to the viewport also emits
    // this event on the link. Only losing our own capture cancels the swipe.
    if (event.target === viewport) reset();
  });
  // A swipe that starts over a link must not activate that link on release.
  viewport.addEventListener(
    "click",
    (event) => {
      if (event.detail > 0 && performance.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
};
